module.exports = __webpack_public_path__ + "media/images/import-guide-1-bd51b0d5ea6862b7e194ba7a5986a300.svg";